<script>
  import { Collection } from "sveltefire";
  import { link, navigate } from "svelte-routing";

  import configStore from "../stores/config-store.js";
  const config = $configStore;

  import ProgressBlobs from "../components/order/ProgressBlobs.svelte";
  import OrderFooter from "../components/order/OrderFooter.svelte";
  import FooterPaymentAmount from "../components/order/Footer_paymentAmount.svelte";

  import StepData from "../components/order/Step_data.svelte";
  import StepOrder from "../components/order/Step_order.svelte";
  import StepPayment from "../components/order/Step_payment.svelte";
  import StepFinish from "../components/order/Step_finish.svelte";

  export let orderFrame;
  export let userRef;
  export let userId;
  export let userdata;

  let currentState = 1;

  let userSelection = {
    data: {
      school: undefined,
      class: "",
      kidName: "",
    },
    order: {
      weekSlices: {
        //"13": "choco" or "13": "uht_choco"
      },
      baseSum: 0,
      heroFee: 0,
      totalSum: 0,
    },
  };

  let schools = [
    {
      code: "friedrichEbertGrundschuleDuesseldorf",
      name: "Friedrich Ebert Grundschule",
      city: "Düsseldorf",
      milkOption: "uhtmilk",
      unavailableDays: ["1620129600", "1620648000"],
    },
    {
      code: "anneFrankGrundschuleDuisburg",
      name: "Anne Frank Grundschule",
      city: "Duisburg",
      milkOption: "freshmilk",
      unavailableDays: [],
    },
  ];

  let milkTypeOfSchool;
  let schooldayAdjustedOrderFrame;

  function getWeekNumber(d) {
    // Copy date so don't modify original
    d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
    // Set to nearest Thursday: current date + 4 - current day number
    // Make Sunday's day number 7
    d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
    // Get first day of year
    var yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
    // Calculate full weeks to nearest Thursday
    var weekNo = Math.ceil(((d - yearStart) / 86400000 + 1) / 7);
    // Return array of year and week number
    return weekNo;
  }

  function adjustOrderFrameSchoolDays(orderFrame, schoolCode) {
    if (schoolCode.length >= 3) {
      let zwOrderFrame = orderFrame;
      let currentSchool = schools.find((el) => el.code == schoolCode);
      zwOrderFrame.weekSlices.forEach((week, i) => {
        let countFreeDaysInThisWeek = 0;
        let weekBegin = new Date(1000 * week.dateBegin);
        currentSchool.unavailableDays.forEach((timestamp) => {
          let freeDay = new Date(timestamp * 1000);
          //falls gleiche Woche, aber nicht Samstag oder Sonntag
          if (
            getWeekNumber(freeDay) == getWeekNumber(weekBegin) &&
            freeDay.getDay() != 6 &&
            freeDay.getDay() != 0
          ) {
            countFreeDaysInThisWeek++;
          }
        });
        zwOrderFrame.weekSlices[i].adjustedSchoolDays =
          zwOrderFrame.weekSlices[i].regularSchoolDays -
          countFreeDaysInThisWeek;
      });
      schooldayAdjustedOrderFrame = zwOrderFrame;
    } else {
      console.log("no school code", schoolCode);
    }
  }

  $: adjustOrderFrameSchoolDays(orderFrame, userSelection.data.school);

  //set initial school for userSelection.data
  handleNewUserSelectionData({
    detail: { school: schools[0].code, class: "", kidName: "" },
  });

  function handleNewMilkSelection(ev) {
    if (ev.detail.selection == null) {
      delete userSelection.order.weekSlices[ev.detail.weekNo];
      userSelection = userSelection; //damit Svelte aktualisierung sendet
    } else {
      userSelection.order.weekSlices[ev.detail.weekNo] = ev.detail.selection;
    }
  }

  function handleNewBaseSum(ev) {
    userSelection.order.baseSum = ev.detail;
    userSelection.order.heroFee =
      Math.round(userSelection.order.baseSum * 0.1 * 100) / 100;
    userSelection.order.totalSum =
      userSelection.order.baseSum + userSelection.order.heroFee;
  }

  function handleNewUserSelectionData(ev) {
    //update milkTypeOfSchool
    if (typeof ev.detail.school != "undefined") {
      let selectedSchool = schools.find(
        (item) => item.code == ev.detail.school
      );
      milkTypeOfSchool = selectedSchool.milkOption;
    }

    //empty orderSelection if school has changed
    userSelection.order = {
      weekSlices: {},
      baseSum: 0,
      heroFee: 0,
      totalSum: 0,
    };

    userSelection.data = ev.detail;
  }

  function validateUserSelectionData(userSelection) {
    let validated = true;
    if (
      typeof userSelection.data.school == "undefined" ||
      userSelection.data.school.length <= 3 ||
      userSelection.data.class.length == 0 ||
      userSelection.data.kidName.length <= 2
    ) {
      validated = false;
    }
    return validated;
  }
  $: userSelectionDataValidated = validateUserSelectionData(userSelection);

  function validateTotalPrice(userSelection) {
    //and also that every week is selected!
    let validated = true;
  
    if (Object.keys(userSelection.order.weekSlices).length != orderFrame.weekSlices.length) {
      validated = false;
    }

    if (userSelection.order.totalSum < 3.5) {
      validated = false;
    }
    return validated;
  }
  $: totalPriceValidated = validateTotalPrice(userSelection);

  let paymentResult;
  function handleNewPaymentResult(ev) {
    paymentResult = ev.detail.state;
  }

  function validateDirectDebitMandate(paymentResult) {
    let validated = false;
    if (paymentResult == 3 || paymentResult == 5) {
      validated = true;
    }
    return validated;
  }
  $: directDebitMandateValidated = validateDirectDebitMandate(paymentResult);

  function handleStepChange(newState) {
    if (newState >= 2 && !validateUserSelectionData(userSelection)) {
      //falls UserSelectionData nicht vollständig sind
      alert("Bitte alle Eingabefelder ausfüllen.");
      return;
    }

    if (newState >= 3 && !validateTotalPrice(userSelection)) {
      //falls Mindestbestellwert nicht erreicht wurde
      alert("Bitte für jede verfügbare Woche Milch auswählen sowie den Mindestbestellwert von 3,50 € erreichen.");
      return;
    }

    if (newState >= 4 && !validateDirectDebitMandate(paymentResult)) {
      //falls noch kein Lastschriftmandat vorhanden
      alert("Bitte Lastschriftmandat erstellen.");
      return;
    }

    currentState = newState;
  }

  function createOrderNo() {
    let orderNo = "";
    let now = new Date();
    orderNo += now.getFullYear();
    orderNo += (now.getMonth() + 1) < 10 ? "0" + (now.getMonth() + 1): (now.getMonth() + 1);
    orderNo += now.getDate() < 10 ? "0" + now.getDate(): now.getDate();
    orderNo += now.getHours() < 10 ? "0" + now.getHours(): now.getHours();
    orderNo += now.getMinutes() < 10 ? "0" + now.getMinutes(): now.getMinutes();
    orderNo += now.getSeconds() < 10 ? "0" + now.getSeconds(): now.getSeconds();
    orderNo += now.getMilliseconds();
    return orderNo;
  }
  let cleanOrderItemsFromFinishStep;
  function placeOrder(ordersRef) {
    let newOrder = {
      orderNo: createOrderNo(),
      orderFrame: orderFrame.id,
      cleanOrderFrameObj: orderFrame,
      childName: userSelection.data.kidName,
      class: userSelection.data.class,
      school: userSelection.data.school,
      selection: userSelection.order.weekSlices,
      cleanOrderItems: cleanOrderItemsFromFinishStep,
      cleanSchoolObj: schools.find( item => item.code == userSelection.data.school),
      baseSum: userSelection.order.baseSum,
      heroFee: userSelection.order.heroFee,
      totalSum: userSelection.order.totalSum,
      status: "ordered",
      createdAt: new Date().getTime(),
      gcCustomer: userdata.gcCustomer,
      gcMandate: userdata.gcMandate,
    };

    fetch(`${config.urls.backend}/mail/orderConfirmation`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        user: userdata,
        order: newOrder
      }),
    })

    console.log(newOrder);
    ordersRef.add(newOrder);
    navigate("/dashboard", { replace: true });
  }
</script>

<div class="animate__fadeIn animate__animated">
  <nav class="backBtn" aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <a href="/dashboard" use:link> &#60; Zurück zum Dashboard</a>
      </li>
    </ol>
  </nav>

  <ProgressBlobs
    {currentState}
    on:stepChange={(ev) => handleStepChange(ev.detail)}
  />
  {#if typeof schooldayAdjustedOrderFrame != "undefined"}
    <Collection
      path={userRef.collection("orders")}
      query={(ref) => ref.orderBy("createdAt")}
      let:data={orders}
      let:ref={ordersRef}
      log
    >
      {#if currentState == 1}
        <StepData
          {schools}
          userSelectionData={userSelection.data}
          on:newUserSelectionData={handleNewUserSelectionData}
        />
        <OrderFooter
          btnDisabled={!userSelectionDataValidated}
          on:btnClicked={() => handleStepChange(currentState + 1)}
          flexibleHeight={true}
        />
      {:else if currentState == 2}
        <StepOrder
          orderFrame={schooldayAdjustedOrderFrame}
          {milkTypeOfSchool}
          userSelectionOrder={userSelection.order}
          on:newSelection={handleNewMilkSelection}
        />
        <OrderFooter
          btnDisabled={!totalPriceValidated}
          on:btnClicked={() => handleStepChange(currentState + 1)}
        >
          <FooterPaymentAmount
            on:newBaseSum={handleNewBaseSum}
            {milkTypeOfSchool}
            orderFrame={schooldayAdjustedOrderFrame}
            userSelectionOrder={userSelection.order}
          />
        </OrderFooter>
      {:else if currentState == 3}
        <StepPayment
          {userId}
          {userdata}
          on:newPaymentResult={handleNewPaymentResult}
        />
        <OrderFooter
          btnDisabled={!directDebitMandateValidated}
          on:btnClicked={() => handleStepChange(currentState + 1)}
        />
      {:else if currentState == 4}
        <StepFinish
          {userSelection}
          {orderFrame}
          {userdata}
          on:cleanOrderItems={ (ev) => cleanOrderItemsFromFinishStep = ev.detail}
        />
        <OrderFooter
          on:btnClicked={() => placeOrder(ordersRef)}
          btnText={"Kostenpflichtig Bestellen"}
        />
      {:else}
        <h1>Error: OrderState unknown: {currentState}</h1>
      {/if}
      <span slot="loading">Lade...</span>
    </Collection>
  {/if}
</div>

<style>
  .backBtn {
    margin-top: 30px;
  }
  .breadcrumb-item {
    cursor: pointer;
    background: #ec9600;
    border-radius: 30px;
    padding: 6px 15px;
    transition: background 0.2s ease-in-out;
  }
  .breadcrumb-item:hover {
    background: #df8d00;
  }
  .breadcrumb-item > a {
    text-decoration: none;
    color: #fff;
  }
</style>
